<template>
  <v-dialog v-model="drawerOpen" max-width="700px">
    <v-card>
      <!-- Toolbar -->
      <v-toolbar dark color="primary">
        <v-toolbar-title>Notifications</v-toolbar-title>
        <v-spacer></v-spacer>

        <!-- Mark as Read Icon (Open Letter) -->
        <v-btn v-if="notifications.length !== 0" icon @click="ToggleMarkAsRead()" title="Mark as Read">
          <v-icon>mdi-check-all</v-icon>
        </v-btn>

        <!-- Clear Notifications Icon (Rubbish Bin) -->
        <v-btn v-if="notifications.length !== 0" icon @click="ToggleclearNotifications()" title="Delete All">
          <v-icon>mdi-delete-outline</v-icon>
        </v-btn>

        <!-- Close Icon -->
        <v-btn icon @click="closeDrawer()" title="Close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider></v-divider>

      <!-- Notification Content -->
      <v-layout @click.stop>
        <v-flex style="width: 600px;">
          <!-- Scrollable List -->
          <div v-if="loading">
          <!-- Skeleton Loader for Notifications -->
          <v-list-item
            v-for="index in 4"
            :key="index"
            style="border-bottom: 1px solid #ccc;"
          >
            <!-- Skeleton Read/Unread Box -->
            <div
              class="skeleton-box notification-state-box"
              style="width: 50px; height: 24px;"
            ></div>

            <!-- Skeleton Content -->
            <v-list-item-content>
              <div class="skeleton-box" style="width: 70%; height: 16px;"></div>
              <div
                class="skeleton-box"
                style="width: 50%; height: 14px; margin-top: 8px;"
              ></div>
            </v-list-item-content>

            <!-- Skeleton Actions -->
            <v-list-item-action style="align-items: center;">
              <div
                class="skeleton-box"
                style="width: 60px; height: 30px; margin-bottom: 10px;"
              ></div>
              <div class="skeleton-box" style="width: 60px; height: 30px;"></div>
            </v-list-item-action>
          </v-list-item>
          </div>
          <h2 class="text-center my-5" v-else-if="notifications.length === 0">You have no new notifications</h2>
          <v-list v-else three-line style="max-height: 400px; overflow-y: auto;">
            <v-list-item
              v-for="(notification) in notifications"
              :key="notification.id"
              style="border-bottom: 1px solid #ccc;"
            >
              <!-- Read/Unread Box -->
              <div v-if="!notification.is_read" class="notification-state-box">
                NEW
              </div>

              <!-- Notification Content -->
              <v-list-item-content>
                <v-list-item-title>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <!-- Render title with v-html -->
                      <v-list-item-title v-bind="attrs" v-on="on">
                        <span v-html="notification.title"></span>
                      </v-list-item-title>
                    </template>
                    <!-- Render raw HTML in the tooltip -->
                    <span v-html="notification.title"></span>
                  </v-tooltip>
                </v-list-item-title>
                <v-list-item-subtitle>{{ formatDate(notification.created_at) }}</v-list-item-subtitle>
              </v-list-item-content>

              <!-- Actions -->
              <v-list-item-action style="align-items: center;">
                <!-- Open Button -->
                <v-btn text @click="redirectCourse(notification.data)" v-if="notification.is_admin_read == 0">
                  <v-icon small>mdi-open-in-new</v-icon>
                  Open
                </v-btn>

                <!-- Remove Button -->
                <v-btn text color="red" @click="removeNotification(notification.id)">
                  <v-icon small>mdi-delete</v-icon>
                  Remove
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <!-- Pagination Controls -->
          <div v-if="notifications.length !== 0" style="display: flex; justify-content: center; align-items: center; margin: 10px;">
            <v-btn
              text
              icon
              :disabled="currentPage === 1"
              @click="changePage(currentPage - 1)"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <span style="font-weight: bold; margin: 0 10px;">{{ currentPage }}</span>
            <v-btn
              text
              icon
              :disabled="hasMore"
              @click="changePage(currentPage + 1)"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import { IMPROVE_CONFIG } from '@/config.js';
import axios from 'axios';

export default {
  name: 'NotificationDrawer',
  props: {
    notificationDrawer: {
      type: Boolean,
      default: false,
    },
    updateNotificationCount : {
      type: Function,
      default: () => {},
    }
  },
  data() {
    return {
      notifications: [],  // Notifications
      color: this.$globalConfig.APP_NAME == 'senso' ? 'dark-blue' : 'dark-grey', // App color
      loading: false, // Loading state
      currentPage: 1, // Current page number
      hasMore: true, // To check if there are more notifications
    };
  },
  computed: {
    drawerOpen: {
      get() {
        return this.notificationDrawer;
      },
      set(value) {
        EventBus.$emit('update:notificationDrawer', value);
      },
    },
  },
  mounted() {
    this.getNotifications();
  },
  methods: {
    formatDate(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString(undefined, options);
    },
    closeDrawer() {
      this.drawerOpen = false;
    },
    redirectCourse(data) {
      this.drawerOpen = false;
      if (
        data.notification_type != undefined &&
        data.notification_type == 'playlist'
      ) {
        this.$router.push('/playlist/details/' + data.channel_id);
      } else if (
        data.notification_type != undefined &&
        data.notification_type == 'external_training'
      ) {
        this.$router.push('/profile/external-training/');
      } else {
        this.$router.push('/courses/player/' + data.course_id);
      }
    },
    ToggleclearNotifications() {
      this.$snotify.confirm('Are you sure you want to delete all notifications?', {
        backdrop: 0.3,
        buttons: [
          { text: "No", className: 'toast-cancel-button' },
          {
            text: "Yes", className: 'toast-continue-button',
            action: toast => this.clearNotifications()
          }          
        ]
      });
    },
    clearNotifications() {
      this.$snotify.remove(); // Remove the confirmation toast
      const backdrop = document.querySelector('.snotify-backdrop');
      if (backdrop) {
          backdrop.parentNode.removeChild(backdrop);
      }
      this.loading = true;
      axios.get(IMPROVE_CONFIG.API_URL + '/clear-notifications').then(() => {
        this.notifications = [];
        this.loading = false;

        // Emit event to parent
        EventBus.$emit('notifications-read');

        //  Show success message
        this.$snotify.success('All notifications deleted')
      })
      .catch(() => {
          this.$snotify.error('Failed to clear notifications');
          this.loading = false;
      });
    },
    removeNotification(id) {
      this.loading = true;
      axios.delete(IMPROVE_CONFIG.API_URL + '/notification/' + id).then(() => {
        this.getNotifications();
        this.loading = false;
      })
      .catch(() => {
          this.$snotify.error('Failed to remove notification');
          this.loading = false;
      });
    },
    getNotifications(page = 1) {
      this.loading = true;
      axios
        .get(`${IMPROVE_CONFIG.API_URL}/get-notifications?page=${page}`)
        .then((response) => {
          this.notifications = response.data.data; // Update the notifications with response

          // if no more notifications and page is greater than 1, then change the page to previous page
          if (this.notifications.length == 0 && page > 1) {
            this.changePage(page - 1);
            this.$snotify.warning('No more notifications');
          }

          this.hasMore = response.data.meta.pagination.total_pages <= this.currentPage ? true : false; // Check if there are more notifications
          this.loading = false;
        })
        .catch(() => {
          this.$snotify.error('Failed to get notifications');
            this.loading = false;
        });
    },
    changePage(page) {
      this.currentPage = page; // Update the current page
      this.getNotifications(page); // Fetch notifications for the new page
    },
    ToggleMarkAsRead() {
      this.$snotify.confirm('Are you sure you want to mark all notifications as read?', {
        backdrop: 0.3,
        buttons: [
          { text: "No", className: 'toast-cancel-button' },
          {
            text: "Yes", className: 'toast-continue-button',
            action: toast => this.markAsRead()
          }          
        ]
      });
    },
    markAsRead() {     
      this.$snotify.remove(); // Remove the confirmation toast
      const backdrop = document.querySelector('.snotify-backdrop');
      if (backdrop) {
          backdrop.parentNode.removeChild(backdrop);
      }
      this.loading = true;
      axios.get(IMPROVE_CONFIG.API_URL + '/read-notifications').then(() => {
        this.loading = false;

        // Emit event to parent
        EventBus.$emit('notifications-read');

        //  Show success message
        this.$snotify.success('All notifications marked as read')
      })
      .catch(() => {
          this.$snotify.error('Failed to mark all notifications as read');
          this.loading = false;
      });
    },
  },
};
</script>

<style>
.unread {
  background: #ffffef;
}
.v-navigation-drawer {
  min-height: 400px !important;
}
.parentNotification {
  min-height: unset !important;
  color: #000000 !important;
  padding: unset !important;
}
.notificationDiv > .v-list-item__title {
  white-space: normal !important;
}

.clear-notification-btn {
  margin-right: 10px;
}

.theme--dark.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(
    .v-data-table__empty-wrapper
  ) {
  background: #eeeeee !important;
}

.notification-state-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 24px;
  border-radius: 4px;
  color: #fff;
  background-color: #ff5252;
  font-weight: bold;
  text-align: center;
  margin-right: 20px;
  font-size: 12px;
}

/* Skeleton Box Styling */
.skeleton-box {
  background: #e0e0e0; /* Light grey background */
  border-radius: 4px;
  animation: skeleton-loading 1.5s infinite;
}

/* Skeleton Loading Animation */
@keyframes skeleton-loading {
  0% {
    background-color: #e0e0e0;
  }
  50% {
    background-color: #f0f0f0;
  }
  100% {
    background-color: #e0e0e0;
  }
}
</style>

<style scoped>
th.text-start.sortable {
  display: none;
}

.custom-text {
  color: rgba(0, 0, 0, 0.87);
}
.v-toolbar__content {
  justify-content: end;
}
</style>

